// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__vhpKP","dataWrapper":"dashboard_dataWrapper__CtJx3"};